/*
 * Bottom-Drawer der PDP-Groessenauswahl.
 *
 * Der Drawer ist reine Oberflaeche: Die Zeilen schreiben ihre Auswahl in die
 * ausgeblendeten Selects aus product-variants.liquid und feuern dort ein
 * change-Event. Variantenermittlung, Verfuegbarkeit, Warteliste und der
 * eigentliche Add-to-Cart laufen unveraendert ueber bs-product-variants.js und
 * application.js.
 */
(() => {
	'use strict';

	const OPEN_CLASS = 'is-open';
	const BODY_CLASS = 'bs-size-drawer-open';

	function initSizeDrawer() {
		const drawer = document.querySelector('[data-js-size-drawer]');
		const productForm = document.querySelector('form.product-form-main');

		if (!drawer || !productForm) return;

		// .section-product__actions ist position: sticky und spannt damit einen
		// Stacking-Context auf, der den fixierten Drawer hinter dem Header
		// einsperren wuerde. Die Handler von application.js und
		// bs-product-variants.js haengen zu diesem Zeitpunkt bereits am Button
		// und ueberleben das Verschieben.
		document.body.appendChild(drawer);

		const trigger = document.querySelector('[data-js-size-trigger]');
		const sizeOptions = Array.prototype.slice.call(drawer.querySelectorAll('[data-js-size-option]'));
		const errorMessage = drawer.querySelector('[data-js-size-drawer-error]');
		const atcButton = drawer.querySelector('[data-js-drawer-atc]');
		const variantIdField = productForm.querySelector('select[name="id"]');

		function getOptionSelects() {
			const selects = [];
			for (let i = 1; i <= 3; i++) {
				const select = productForm.querySelector('select[name="variant' + i + '"]');
				if (select) selects.push(select);
			}
			return selects;
		}

		function hasCompleteSelection() {
			const selects = getOptionSelects();
			if (!selects.length) return false;
			return selects.every(function (select) {
				return select.value && select.value !== '';
			});
		}

		// True only when select[name="id"] is enabled and still matches the current
		// option selects. Prevents a stale id (from the 10ms debounce in
		// bs-product-variants.js) from looking "ready", and keeps ATC off for
		// invalid multi-option combinations where the id field stays disabled.
		function hasResolvedVariant() {
			if (!variantIdField || variantIdField.disabled || !variantIdField.value) {
				return false;
			}

			const selectedOption = variantIdField.querySelector(
				'option[value="' + variantIdField.value + '"]'
			);
			if (!selectedOption) return false;

			const selects = getOptionSelects();
			for (let i = 0; i < selects.length; i++) {
				const attr = selectedOption.getAttribute('data-variant' + (i + 1));
				if ((attr || '') !== selects[i].value) return false;
			}

			return true;
		}

		function resolveVariantId() {
			if (typeof productForm.resolveVariantId === 'function') {
				return productForm.resolveVariantId();
			}
			return hasResolvedVariant();
		}

		const defaultErrorText = errorMessage ? errorMessage.textContent.trim() : '';
		const genericAtcError = (errorMessage && errorMessage.getAttribute('data-generic-error')) || defaultErrorText;
		const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

		function showError(message) {
			if (!errorMessage) return;
			errorMessage.textContent = message || defaultErrorText;
			errorMessage.classList.remove('hidden');
		}

		function hideError() {
			if (errorMessage) errorMessage.classList.add('hidden');
		}

		function logAddFailure(response, text) {
			console.warn('[bs-size-drawer] cart/add.js', {
				status: response ? response.status : null,
				contentType: response && response.headers ? response.headers.get('content-type') : null,
				preview: (text || '').slice(0, 120)
			});
		}

		// Der Drawer legt selbst in den Warenkorb, statt den Klick an
		// application.js weiterzureichen. Sonst laeuft der Submit des Formulars
		// durch und die Seite landet auf /cart statt im Cart-Drawer.
		function addToCart() {
			if (!atcButton || atcButton.classList.contains('is-loading')) return;

			// FormData laesst disabled Fields weg; ohne aufgeloeste Variante wuerde
			// der Request ohne id rausgehen.
			if (!resolveVariantId() || !hasResolvedVariant()) {
				showError();
				updateAtcState();
				return;
			}

			atcButton.classList.add('is-loading');
			hideError();

			const formData = new FormData(productForm);
			if (!formData.has('id') && variantIdField.value) {
				formData.append('id', variantIdField.value);
			}

			fetch(cartRoot + 'cart/add.js', {
				method: 'POST',
				headers: { Accept: 'application/json' },
				body: formData
			})
				.then(function (response) {
					return response.text().then(function (text) {
						let data = null;
						try {
							data = JSON.parse(text);
						} catch (err) {
							data = null;
						}

						if (!response.ok || !data) {
							logAddFailure(response, text);
							showError((data && data.description) || genericAtcError);
							return null;
						}
						return data;
					});
				})
				.then(function (data) {
					if (!data) return;
					if (typeof window.countCartItems === 'function') {
						window.countCartItems();
					}
					closeDrawer();
					// Derselbe Weg wie beim regulaeren Add-to-Cart: layout/theme.liquid
					// oeffnet daraufhin den Cart-Drawer, bs-product-variants.js setzt
					// die Groessenauswahl zurueck.
					document.dispatchEvent(new CustomEvent('formProductAdded'));
				})
				.catch(function () {
					showError(genericAtcError);
				})
				.finally(function () {
					atcButton.classList.remove('is-loading');
				});
		}

		// Der Wishlist-Mount im Drawer liegt nach dem Verschieben ausserhalb der
		// Produkt-Section, die Variantensynchronisation aus bs-product-variants.js
		// erreicht ihn dort nicht mehr.
		function syncWishlistVariant() {
			if (!variantIdField || !variantIdField.value) return;
			drawer.querySelectorAll('.wishlist-engine').forEach(function (mount) {
				mount.setAttribute('data-variant_id', variantIdField.value);
			});
		}

		// Ohne aufgeloeste, zur Auswahl passende Variante bleibt der Button
		// ausgegraut und heisst "Select Size". Bewusst ueber eine Klasse statt
		// ueber das disabled-Attribut, weil bs-product-variants.js dieses bei
		// jedem Variantenwechsel zuruecksetzt.
		function updateAtcState() {
			if (!atcButton) return;

			const isReady = hasCompleteSelection() && hasResolvedVariant();
			atcButton.classList.toggle('is-disabled', !isReady);
			atcButton.setAttribute('aria-disabled', isReady ? 'false' : 'true');
			atcButton.textContent = isReady
				? atcButton.dataset.labelAdd
				: atcButton.dataset.labelSelect;
		}

		function syncActiveOptions() {
			sizeOptions.forEach(function (option) {
				const select = productForm.querySelector('select[name="variant' + option.dataset.optionIndex + '"]');
				const isActive = !!select && select.value === option.dataset.value;
				option.classList.toggle('is-active', isActive);
				option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
			});
		}

		function openDrawer(options) {
			drawer.classList.add(OPEN_CLASS);
			drawer.setAttribute('aria-hidden', 'false');
			document.body.classList.add(BODY_CLASS);
			syncActiveOptions();
			updateAtcState();

			// Sticky ATC und andere externe Trigger koennen die Validierung
			// fehlschlagen lassen, ohne dass der Drawer schon offen ist - dann
			// Fehlerhinweis direkt mit anzeigen.
			if (options && options.showError) {
				showError(options.errorMessage);
			}
		}

		function closeDrawer() {
			drawer.classList.remove(OPEN_CLASS);
			drawer.setAttribute('aria-hidden', 'true');
			document.body.classList.remove(BODY_CLASS);
			hideError();
		}

		// Von bs-product-variants.js genutzt, wenn Sticky-ATC ohne Groesse
		// abgesetzt wird und die ausgeblendeten Selects nicht fokussiert
		// werden sollen.
		productForm.openSizeDrawer = function (options) {
			openDrawer(options || {});
		};

		// Komplett ausverkauft: der Buy-Row-Trigger ist selbst der Klaviyo-
		// Waitlist-Button. Drawer nicht oeffnen, sonst faengt preventDefault
		// den App-Klick ab.
		if (trigger && !trigger.classList.contains('klaviyo-bis-trigger')) {
			trigger.addEventListener('click', function (event) {
				event.preventDefault();
				openDrawer();
			});
		}

		document.addEventListener(
			'click',
			function (event) {
				const bisTrigger = event.target.closest ? event.target.closest('.klaviyo-bis-trigger') : null;
				if (!bisTrigger || bisTrigger.classList.contains('button--hidden')) return;

				const isWaitlist = bisTrigger.hasAttribute('data-js-waitlist-trigger');
				const placeholder = bisTrigger.getAttribute('data-label-select') || '';
				let attempts = 0;

				function patchModalSelect() {
					attempts += 1;
					const iframe = document.getElementById('klaviyo-bis-iframe');
					let doc = null;
					let select = null;

					try {
						doc = iframe && (iframe.contentDocument || iframe.contentWindow.document);
						select = doc && doc.querySelector('#variants');
					} catch (err) {
						select = null;
					}

					if (!select) {
						if (attempts < 20) setTimeout(patchModalSelect, 50);
						return;
					}

					if (!doc.querySelector('link[data-bs-drawer-css]')) {
						const source = document.querySelector('link[href*="bs-size-drawer.css"]');
						if (source) {
							const link = doc.createElement('link');
							link.rel = 'stylesheet';
							link.href = source.href;
							link.setAttribute('data-bs-drawer-css', 'true');
							doc.head.appendChild(link);
						}
					}

					if (isWaitlist) {
						if (!select.querySelector('[data-bs-placeholder]')) {
							const option = doc.createElement('option');
							option.value = '';
							option.textContent = placeholder;
							option.setAttribute('data-bs-placeholder', 'true');
							select.insertBefore(option, select.firstChild);
						}
						select.value = '';
					}

					select.classList.toggle('is-placeholder', !select.value);
					if (!select.dataset.bsStyled) {
						select.dataset.bsStyled = 'true';
						select.addEventListener('change', function () {
							select.classList.toggle('is-placeholder', !select.value);
						});
					}

					if (!isWaitlist) {
						const modalButton = doc.querySelector('.btn, button[type="submit"]');
						if (modalButton) {
							modalButton.textContent = bisTrigger.getAttribute('data-label-notify') || bisTrigger.textContent.trim();
							modalButton.classList.add('bs-bis-notify');
						}
						if (attempts < 8) setTimeout(patchModalSelect, 50);
					}
				}

				setTimeout(patchModalSelect, 50);
			},
			true
		);

		drawer.querySelectorAll('[data-js-size-drawer-close]').forEach(function (element) {
			element.addEventListener('click', function (event) {
				event.preventDefault();
				closeDrawer();
			});
		});

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && drawer.classList.contains(OPEN_CLASS)) {
				closeDrawer();
			}
		});

		sizeOptions.forEach(function (sizeOption) {
			sizeOption.addEventListener('click', function () {
				const select = productForm.querySelector('select[name="variant' + sizeOption.dataset.optionIndex + '"]');
				if (!select) return;

				select.value = sizeOption.dataset.value;
				select.dispatchEvent(new Event('change', { bubbles: true }));

				hideError();
				syncActiveOptions();
				updateAtcState();

				// bs-product-variants.js schreibt die Variante mit 10ms Debounce,
				// die Wishlist wird daher erst danach nachgezogen.
				setTimeout(syncWishlistVariant, 50);
			});
		});

		// Capture-Phase auf document, damit der Klick weder den Submit-Handler von
		// bs-product-variants.js noch den Add-to-Cart von application.js erreicht.
		// Beide wuerden sonst zusaetzlich feuern - einmal doppelt in den Warenkorb,
		// einmal mit geoeffnetem Cart-Drawer.
		document.addEventListener(
			'click',
			function (event) {
				const target = event.target.closest ? event.target.closest('[data-js-drawer-atc]') : null;
				if (!target) return;

				event.preventDefault();
				event.stopImmediatePropagation();

				if (!hasCompleteSelection()) {
					showError();
					updateAtcState();
					return;
				}

				addToCart();
			},
			true
		);

		document.addEventListener('variant:change', function () {
			updateAtcState();
			syncWishlistVariant();
		});

		// bs-product-variants.js setzt nach jedem Add-to-Cart die Selects zurueck,
		// Liste und Button im Drawer muessen danach nachziehen.
		document.addEventListener('formProductAdded', function () {
			closeDrawer();
			setTimeout(function () {
				syncActiveOptions();
				updateAtcState();
			}, 50);
		});

		function syncWaitlistLabel() {
			const waitlistButton = drawer.querySelector('.klaviyo-bis-trigger');
			if (waitlistButton && waitlistButton.dataset.labelNotify) {
				waitlistButton.textContent = waitlistButton.dataset.labelNotify;
			}
		}

		syncActiveOptions();
		updateAtcState();
		syncWishlistVariant();
		syncWaitlistLabel();
		// Klaviyo kann den Trigger-Text nach dem Init auf "Join the waitlist"
		// zuruecksetzen. Label danach wiederherstellen.
		setTimeout(syncWaitlistLabel, 500);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSizeDrawer);
	} else {
		initSizeDrawer();
	}
})();
